import { graphql } from "../gql";

export const drgCreateFindingsMutationDoc = graphql(`
  mutation drgCreateFindings($input: DrgCreateFindingsInput!) {
    drgCreateFindings(input: $input) {
      id
      claimId
      module
      verdict
      code
      codeDescription
      detectedRole
      confidence
      poaValue
      poaCitationPage
      agentName
      agentDiagnosisType
      agentGovernedCodes
      agentRunId
      aiNarrative
      clinicalFindings
      disposition
      dispositionActor {
        id
        email
        displayName
        orgId
      }
      dispositionAt
      author {
        __typename
        ... on DrgUser {
          id
          displayName
        }
        ... on DrgAgent {
          id
          name
        }
      }
      supportingEvidence {
        id
        kind
        title
        description
        sourceType
        evidenceDate
        citationPage
        disqualifiesAs
        isPinned
        negated
        pinnedAt
      }
      disqualifyingEvidence {
        id
        kind
        title
        description
        sourceType
        evidenceDate
        citationPage
        disqualifiesAs
        isPinned
        negated
        pinnedAt
      }
      proposedChange {
        removeCodes
        addCodes {
          code
          role
          rationale
        }
        reposition {
          code
          fromPosition
          toPosition
        }
      }
      pinnedEvidenceIds
      linkedAnnotations {
        id
        page
        quote
        note
        fileId
        fileName
        citationKey
        sourceText
        evidenceItemId
        coordinates {
          left
          top
          width
          height
        }
      }
      linkedAnnotationCount
      createdAt
      updatedAt
    }
  }
`);
